let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("knvzR")).then(() => parcelRequire('8C75l'));